import moment from "moment";
import React from "react";

import { commonFormatTime } from "@/utilities/utils";

import ClientPayPopover from "../../../dataTables/ClientPayPopover";
import WorkedStatusButton from "../Worked/WorkedStatusButton";

const WorkedShifts = ({
  contract_id,
  shifts,
  dateFormat = "DD/MM/YYYY",
  substitueCon = 0,
}) => {
  return (
    <div className="max-w- ml-[12px] max-h-[250px] overflow-y-scroll bg-[#FCFCFC]">
      <table className="table w-full">
        <thead>
          <tr className="h-[30px] border-b border-b-lightblue text-primary">
            <th
              width="20%"
              className="pl-[76px] !text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Date
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Start
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              End
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Break
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Admin
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Visits
            </th>
            <th
              width="13.5%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Total
            </th>
            <th
              width="11%"
              className="!text-left text-[12px] font-semibold uppercase leading-[normal]"
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {shifts && shifts.length > 0 ? (
            shifts.map((shift, item) => {
              const {
                contract_date,
                start_time,
                end_time,
                break_time,
                admin_time,
                no_of_visit,
                shift_rate,
                timesheet_status,
                client_pay_arr,
                contract_ref_no,
                cover_request_awarded_reward = 0,
                cover_request_awarded_penalty = 0,
              } = shift;
              return (
                <tr
                  key={item}
                  className="h-[30px] border-b border-b-lightblue text-black"
                >
                  <td className="pl-[76px] text-[14px] font-medium leading-[normal]">
                    {moment(contract_date, dateFormat).format("DD/MM/YYYY")}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    {commonFormatTime(start_time, "HH:mm:ss")}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    {commonFormatTime(end_time, "HH:mm:ss")}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    {commonFormatTime(break_time, "HH:mm:ss")}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    {commonFormatTime(admin_time, "HH:mm:ss")}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    {no_of_visit ? no_of_visit : 0}
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    <ClientPayPopover
                      pay_arr={client_pay_arr}
                      // shift_rate={shift_rate}
                      shift_rate={
                        Number(shift_rate) +
                        Number(cover_request_awarded_reward || 0) -
                        Number(cover_request_awarded_penalty || 0)
                      }
                      is_substitute_contract={
                        cover_request_awarded_reward != 0
                          ? 1
                          : cover_request_awarded_penalty != 0
                            ? 1
                            : 0
                      }
                      cover_request_awarded_penalty={
                        cover_request_awarded_penalty || 0
                      }
                      cover_request_awarded_reward={
                        cover_request_awarded_reward || 0
                      }
                      content={(content) => (
                        <>
                          <span className="cursor-pointer">{content}</span>
                        </>
                      )}
                    />
                  </td>
                  <td className="text-[14px] font-medium leading-[normal]">
                    <WorkedStatusButton
                      timesheet_status={timesheet_status}
                      contract_ref_no={contract_ref_no}
                      btnClass="my-2 inline-block h-[24px] rounded-md px-2 font-medium leading-[24px]"
                    />
                  </td>
                </tr>
              );
            })
          ) : (
            <tr className="h-[30px] border-b border-b-lightblue text-black">
              <td className="pl-[76px] text-[14px] font-medium leading-[normal]">
                -
              </td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
              <td className="text-[14px] font-medium leading-[normal]">-</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WorkedShifts;
